<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-wallet"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 0: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-wallet tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Grid de Cards -->
      <div class="cards-container">
        <!-- Coluna Esquerda -->
        <div class="column-left">
          <!-- Card Dados da Conta -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon">
                <i class="pi pi-id-card"></i>
              </div>
              <span class="card-header-title">{{'nova-conta.texts.dados_da_conta' | translate}}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <div class="form-field half">
                  <label class="form-label">{{'Titulo_da_conta' | translate}} <span class="required"
                      *ngIf="this.form.tituloDaConta.length < 3">*</span></label>
                  <input type="text" pInputText [(ngModel)]="form.tituloDaConta"
                    [placeholder]="'Titulo_da_conta' | translate" minlength="3" class="w-full" />
                </div>
                <div class="form-field half">
                  <label class="form-label">{{'Numero_da_conta' | translate}} <span class="required"
                      *ngIf="!this.form.numeroConta">*</span></label>
                  <input type="text" pInputText [(ngModel)]="form.numeroConta"
                    [placeholder]="'Numero_da_conta' | translate" class="w-full" />
                </div>
                <div class="form-field half">
                  <label class="form-label">{{'nova-conta.labels.tipo_conta' | translate}} <span class="required"
                      *ngIf="!this.form.tipoConta">*</span></label>
                  <p-dropdown id="tipoConta" [options]="tipoContaOptions" [(ngModel)]="form.tipoConta" optionLabel="label"
                    [placeholder]="'selecionar' | translate"
                    [disabled]="true"
                    styleClass="w-full" appendTo="body">
                  </p-dropdown>
                </div>
                <div class="form-field half">
                  <label class="form-label">{{'nova-conta.labels.descricao' | translate}}</label>
                  <input type="text" pInputText [(ngModel)]="form.descricao"
                    [placeholder]="'nova-conta.placeholders.descricao' | translate" class="w-full" />
                </div>
                <div class="form-field full">
                  <label class="form-label">{{'nova-conta.labels.aceita_tarjeta_qrcode' | translate}}</label>
                  <div class="flex align-items-center gap-2">
                    <p-inputSwitch [(ngModel)]="form.aceitaTarjetaQrcode"></p-inputSwitch>
                    <small class="text-500">{{'nova-conta.texts.aceita_tarjeta_qrcode_ajuda' | translate}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Direita -->
        <div class="column-right">
          <!-- Card Valores -->
          <div class="form-card">
            <div class="card-header">
              <div class="card-header-icon values-icon">
                <i class="pi pi-dollar"></i>
              </div>
              <span class="card-header-title">{{'nova-conta.texts.valores' | translate}}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <div class="form-field half" *ngIf="!removeInputsEdicaoBanco">
                  <label class="form-label">{{'moeda' | translate}} <span class="required"
                      *ngIf="!this.form.moeda">*</span></label>
                  <p-dropdown id="moeda" [options]="moeda" [(ngModel)]="form.moeda" optionLabel="label"
                    (ngModelChange)="onMoedaChange($event)"
                    [placeholder]="'selecionar' | translate"
                    styleClass="w-full" appendTo="body">
                    <ng-template pTemplate="selectedItem" let-moedaItem>
                      <div class="dropdown-moeda-item" *ngIf="moedaItem">
                        <img [src]="moedaItem.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ moedaItem.label }}</span>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-moedaItem>
                      <div class="dropdown-moeda-item">
                        <img [src]="moedaItem.flagUrl" class="flag-icon-small" alt="" />
                        <span>{{ moedaItem.label }}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
                <div class="form-field half" *ngIf="!removeInputsEdicaoBanco">
                  <label class="form-label">{{'Saldo_inicial' | translate}}
                    <span class="required" *ngIf="!this.form.saldoInicial && this.form.saldoInicial !== 0">*</span>
                  </label>
                  <div class="currency-input-container">
                    <input type="text" pInputText
                      [placeholder]="'Saldo_inicial' | translate"
                      class="currency-input-with-symbol w-full"
                      [value]="montanteStr"
                      (input)="formataCampoValor($event)" />
                    <span class="currency-symbol-inside-input">{{ getSelectedCurrencySymbol() }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="'Limpar' | translate" icon="pi pi-eraser"
          (click)="limparForm()" severity="secondary" class="btn-secondary"></button>
        <button *ngIf="!form.id" pButton [label]="'Adicionar' | translate" icon="pi pi-check"
          (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary"></button>
        <button *ngIf="form.id" pButton [label]="'atualizar' | translate" icon="pi pi-check"
          (click)="atualizarConta()" [disabled]="submitting" [loading]="submitting" class="btn-primary"></button>
      </div>
    </p-tabPanel>

    <!-- Aba 1: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <!-- Card: Lista de Contas -->
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.lista_de_contas }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.nova_conta"
              icon="pi pi-plus" (click)="novaConta()" class="btn-primary btn-sm">
            </button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholderPesquisar"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="contas" [loading]="loading"
            (sortFunction)="customSort($event)" [customSort]="true"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 5%">
                  {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('sobre')" pSortableColumn="sobre">
                  {{ labels.sobre }}<p-sortIcon [field]="'sobre'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('totalEntrada')" pSortableColumn="totalEntrada" class="num-col" style="width: 13%">
                  {{ labels.total_entrada }}<p-sortIcon [field]="'totalEntrada'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('totalSaida')" pSortableColumn="totalSaida" class="num-col" style="width: 13%">
                  {{ labels.total_saida }}<p-sortIcon [field]="'totalSaida'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('saldo')" pSortableColumn="saldo" class="num-col" style="width: 12%">
                  {{ labels.saldo }}<p-sortIcon [field]="'saldo'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('dataInclusao')" pSortableColumn="dataInclusao" style="width: 15%">
                  {{ labels.data_inclusao }}<p-sortIcon [field]="'dataInclusao'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 120px; text-align: center">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-conta>
              <tr>
                <td [hidden]="!isColumnVisible('id')">{{ conta.id }}</td>
                <td [hidden]="!isColumnVisible('sobre')">
                  <strong>{{ labels.tipo }}:</strong> {{ tipoEnum(conta) }}<br />
                  <strong>{{ labels.titulo }}:</strong> {{ conta.tituloDaConta }}<br />
                  <strong>{{ labels.descricao }}:</strong> {{ conta.descricao }}
                </td>
                <td [hidden]="!isColumnVisible('totalEntrada')" class="num-col">
                  {{ formatarValorMonetario(conta.valorTotalDeEntradas, conta) }}
                </td>
                <td [hidden]="!isColumnVisible('totalSaida')" class="num-col">
                  {{ formatarValorMonetario(conta.valorTotalDeSaidas, conta) }}
                </td>
                <td [hidden]="!isColumnVisible('saldo')" class="num-col" [ngClass]="{ negative: conta.saldo < 0 }">
                  {{ formatarValorMonetario(conta.saldo, conta) }}
                </td>
                <td [hidden]="!isColumnVisible('dataInclusao')">{{ formatarDataEHora(conta.criadoEm) }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <button pButton icon="pi pi-external-link"
                    class="p-button-text p-button-rounded p-button-sm"
                    [pTooltip]="tooltips.ver_movimentos" tooltipPosition="top"
                    (click)="navegarParaMovimentos(conta)">
                  </button>
                  <ng-container *ngIf="!isContaPadrao(conta)">
                    <button pButton icon="pi pi-pencil"
                      class="p-button-text p-button-rounded p-button-sm"
                      [pTooltip]="tooltips.editar" tooltipPosition="top"
                      (click)="editarConta(conta)">
                    </button>
                    <button pButton icon="pi pi-trash"
                      class="p-button-text p-button-rounded p-button-sm p-button-danger"
                      [pTooltip]="tooltips.excluir" tooltipPosition="top"
                      (click)="deletarConta(conta.id)">
                    </button>
                  </ng-container>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhuma_conta_encontrada }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}" [first]="first3" [rows]="rows"
                [totalRecords]="totalRecords" [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label" optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<p-toast></p-toast>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>
